// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { useTypedParams } from "react-router-typesafe-routes/dom";

import { CallToActionCard } from "~@jii/common-ui";
import { State } from "~@jii/paths";
import { useUsMaTranslations } from "~@jii/translation";

import { useReentryAnalytics } from "../../../../hooks/useReentryAnalytics";
import { RESOURCE_CATEGORIES } from "../../ctaConfigs";
import { CardsList, SectionLabel } from "./ResourceCategoryCta.styles";

export const ResourceCategoryCta = () => {
  const { t } = useUsMaTranslations();
  const routeParams = useTypedParams(State.Resident);
  const trackEvent = useReentryAnalytics();

  return (
    <div>
      <SectionLabel>
        {t(($) => $.reentry.overview.resourceCategories.sectionLabel)}
      </SectionLabel>
      <CardsList>
        {RESOURCE_CATEGORIES.map(
          ({ category, illustrationSrc, illustrationBackground, copy }) => {
            const { heading, description, cta } = copy(t);

            return (
              <CallToActionCard
                key={category}
                linkTo={State.Resident.UsMaReentry.Resources.CategoryResults.buildPath(
                  {
                    ...routeParams,
                    category,
                  },
                )}
                heading={heading}
                description={description}
                linkText={cta}
                illustrationSrc={illustrationSrc}
                illustrationBackground={illustrationBackground}
                onLinkClick={() =>
                  trackEvent("frontend_reentry_home_cta_clicked", {
                    cta: "resource_explorer",
                  })
                }
              />
            );
          },
        )}
      </CardsList>
    </div>
  );
};
